// src/app/auth/AuthGuard.jsx
import useAuth from "app/hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
//import { flatten } from 'lodash'
import routes from "../routes";
import AccessDenied from '../views/sessions/AccessDenied';
// Logger
import logger from '../utils/logger';
const LOG_LOC = { location: `${process.env.REACT_APP_LOG_PREFIX} 'src/app/auth/AuthGuard.jsx'` }

const userHasPermission = (pathname, user, routes) => {
  if (!user) {
    return false;
  }
  // let flatRoutes = [routes];
  const flatRoutes = routes.reduce((acc, curr) => {
    acc.push(curr);
    if (curr.children) {
      acc.push(...curr.children);
    }
    return acc;
  }, []);


  const matched = flatRoutes.find((r) => r.path === pathname);
  // console.log(matched)
  const authenticated =
    matched && matched.auth && matched.auth.length ? matched.auth.includes(user.role) : true;
  return authenticated;
};

export default function AuthGuard({ children }) {
  const { pathname } = useLocation();
  const { isAuthenticated, user } = useAuth();

  const hasPermission = userHasPermission(pathname, user, routes);
  if (isAuthenticated && !hasPermission) {
    return <AccessDenied />;
  }
  let authenticated = isAuthenticated && hasPermission;
  //authenticated = true;
  //logger.debug(`isAuthenticated: ${isAuthenticated} hasPermission: ${hasPermission}`, LOG_LOC);
  if (authenticated) return <>{children}</>;

  return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
}
